
import { useState, useEffect } from 'react';

const ComunidadeHero = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  const scrollToConvite = () => {
    const el = document.getElementById('convite-section');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="relative min-h-[85vh] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/1c95953a3826155e025e91b606f829ed.jpg"
          alt="Comunidade de cartas conectadas"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/85 via-black/65 to-black/45"></div>
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-black/30"></div>
      </div>

      <div className="absolute top-36 right-48 w-2 h-2 bg-gold-500/50 rounded-full animate-float"></div>
      <div className="absolute top-64 right-80 w-1.5 h-1.5 bg-gold-400/30 rounded-full animate-float" style={{ animationDelay: '1.2s' }}></div>
      <div className="absolute bottom-44 right-60 w-1 h-1 bg-gold-300/40 rounded-full animate-float" style={{ animationDelay: '2.4s' }}></div>

      <div className="container mx-auto px-6 lg:px-16 py-20 relative z-10">
        <div className={`max-w-3xl transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
          <div className="flex items-center gap-4 mb-8">
            <div className="w-12 h-px bg-gradient-to-r from-gold-500 to-gold-300"></div>
            <span className="font-['Montserrat'] text-xs tracking-[0.3em] uppercase text-gold-400">
              Comunidade
            </span>
          </div>

          <h1 className="font-['Playfair_Display'] text-5xl lg:text-7xl leading-[1.1] mb-8 text-white">
            <span className="font-normal block">Convide quem você</span>
            <span className="italic font-light block text-gold-400 mt-2">ama a escrever</span>
            <span className="font-bold block mt-2">sua própria carta</span>
          </h1>

          <p className="font-['Montserrat'] text-base lg:text-lg text-white/55 mb-12 leading-relaxed max-w-xl font-light tracking-wide">
            Compartilhe essa experiência transformadora com amigos e familiares. Juntos, construímos uma comunidade de pessoas que acreditam no poder da escrita para o futuro.
          </p>

          <div className="flex flex-col sm:flex-row items-start gap-5">
            <button
              onClick={scrollToConvite}
              className="group bg-gradient-to-r from-gold-500 to-gold-600 text-luxury-black font-['Montserrat'] font-semibold text-sm px-10 py-4 rounded-lg hover:shadow-[0_0_30px_rgba(201,168,76,0.3)] transition-all duration-500 hover:scale-105 flex items-center gap-3 whitespace-nowrap cursor-pointer tracking-wider uppercase"
            >
              <i className="ri-share-forward-fill text-lg"></i>
              Convidar Amigos
              <i className="ri-arrow-right-line text-lg group-hover:translate-x-2 transition-transform duration-300"></i>
            </button>
          </div>

          <div className={`mt-14 flex items-center gap-8 transition-all duration-1000 delay-700 ${isVisible ? 'opacity-100' : 'opacity-0'}`}>
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-full bg-gold-500/10 border border-gold-500/20 flex items-center justify-center">
                <i className="ri-group-fill text-gold-500 text-lg"></i>
              </div>
              <div>
                <p className="font-['Montserrat'] text-sm font-semibold text-gold-400">3.000+</p>
                <p className="font-['Montserrat'] text-[10px] text-white/35 tracking-wide">Membros</p>
              </div>
            </div>
            <div className="w-px h-8 bg-gold-500/15"></div>
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-full bg-gold-500/10 border border-gold-500/20 flex items-center justify-center">
                <i className="ri-global-fill text-gold-500 text-lg"></i>
              </div>
              <div>
                <p className="font-['Montserrat'] text-sm font-semibold text-gold-400">12</p>
                <p className="font-['Montserrat'] text-[10px] text-white/35 tracking-wide">Países</p>
              </div>
            </div>
            <div className="w-px h-8 bg-gold-500/15"></div>
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-full bg-gold-500/10 border border-gold-500/20 flex items-center justify-center">
                <i className="ri-heart-fill text-gold-500 text-lg"></i>
              </div>
              <div>
                <p className="font-['Montserrat'] text-sm font-semibold text-gold-400">1.856</p>
                <p className="font-['Montserrat'] text-[10px] text-white/35 tracking-wide">Convites enviados</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ComunidadeHero;
